import { render } from "./DTag.vue?vue&type=template&id=65c29917&scoped=true"
import script from "./DTag.vue?vue&type=script&lang=js"
export * from "./DTag.vue?vue&type=script&lang=js"

import "./DTag.vue?vue&type=style&index=0&id=65c29917&lang=scss&scoped=true"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c29917"]])

export default __exports__